import {Route, Vote} from "@/types";

export const getRoutes = (): Route[] => {
    try{
        // TODO: zod parsing
        return JSON.parse(localStorage.getItem("climbpress-routes") ?? "[]");
    } catch (e) {
        console.error(e);
    }
    return [];
}

export const setRoutes = (routes: Route[]) => localStorage.setItem("climbpress-routes", JSON.stringify(routes));

type CachedVote = {
    vote: Vote
    voteId: string
}

const getVoteKey = (routeId: number) => `climbpress-vote(route:${routeId})`;
export const setVoteCache = (routeId: number, vote: CachedVote|null) =>{
    if(vote == null){
        localStorage.removeItem(getVoteKey(routeId));
    } else {
        localStorage.setItem(getVoteKey(routeId), JSON.stringify(vote));
    }
}

export const getVoteCache = (routeId: number): CachedVote | null => {
    try {
        const cache = localStorage.getItem(getVoteKey(routeId));
        return cache ?   JSON.parse(cache): null;
    } catch (e) {
        return null;
    }
}